export const searchBarContainer = (theme) => ({
  marginBottom: theme.spacing(2),
  position: "relative",
});

export const searchIcon = (theme) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: "50%",
  transform: "translateY(-50%)",
  color: theme.palette.text.secondary,
});

export const recipeListContainer = (theme) => ({
  color: theme.palette.text.primary,
  maxHeight: "50vh",
  overflowY: "auto",
  "&::-webkit-scrollbar-track": {
    background: theme.palette.background.default,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: theme.palette.divider,
  },
});

export const categoryHeader = (theme) => ({
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.default,
  fontWeight: "bold",
  position: "sticky",
  top: 0,
  zIndex: 1,
});

export const recipeItem = (theme, isSelected = false) => ({
  padding: theme.spacing(0.6, 1),
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  backgroundColor: isSelected ? theme.palette.action.selected : "transparent",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
});

export const recipeTitle = (theme) => ({
  flexGrow: 1,
});

// Style for the selection checkbox/icon
export const recipeCheckIcon = (theme, isSelected) => ({
  color: isSelected ? theme.palette.primary.main : theme.palette.action.active,
  marginLeft: theme.spacing(1),
  fontSize: "1rem",
});

export const emptyResults = (theme) => ({
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
});

export const modalActions = (theme) => ({
  display: "flex",
  justifyContent: "flex-end",
  marginTop: theme.spacing(2),
  gap: theme.spacing(1),
});
